import { PropsWithChildren } from "react";

import { FilterBar, Item } from "@bps/fluent-ui";

export interface CommandsFilterValues {
  name: string;
}

interface CommandsFilterProps extends PropsWithChildren<any> {
  setFilterArgs: React.Dispatch<
    React.SetStateAction<CommandsFilterValues | undefined>
  >;
}

export const CommandsFilter = ({
  setFilterArgs,
  children
}: CommandsFilterProps) => {
  const filterItems: Item<CommandsFilterValues>[] = [
    {
      name: "name",
      type: "searchBox",
      stickItem: true,
      props: { placeholder: "Search by name", removeSpecialCharacters: false }
    }
  ];

  return (
    <FilterBar<CommandsFilterValues>
      items={filterItems}
      initialValues={{
        name: ""
      }}
      onChange={filter => setFilterArgs(filter.state.values)}
    >
      {children}
    </FilterBar>
  );
};
